import * as React from "react";
import { sortBy } from "lodash";
import { Divider, Loader } from "semantic-ui-react";

import { medicalTypes, MedicalTypeId } from "@teamprevent/common/healthSurveillance/models";
import { CaseType } from "@teamprevent/common/model";

import { useCustomMedicalTypes } from "../../../../../customMedicalTypes/hooks/useCustomMedicalTypes";
import { getPpqOutcome } from "../../../../../triage/models";
import { PartialOhCaseDetailModel } from "../../../model";

interface Props {
    ohCase: PartialOhCaseDetailModel;
}

export const HealthSurveillanceCaseInfo: React.FunctionComponent<Props> = (props: Props) => {

    const { customMedicalTypes, isLoaded } = useCustomMedicalTypes();

    const workGroups = props.ohCase?.workGroups ?? [];

    const ohCaseMedicalTypeIds: MedicalTypeId[] = props.ohCase?.medicalTypes ?? [];

    let mergedMedicals: {id: string; name: string}[] = medicalTypes;
    if (isLoaded) {
        mergedMedicals = mergedMedicals.concat(customMedicalTypes);
    }

    const ohCaseMedicalTypes: { id: string; name: string}[] = mergedMedicals.filter(mt => ohCaseMedicalTypeIds?.find(mdi => mdi === mt.id));

    const deactivatedMedicalTypeIds: MedicalTypeId[] = props.ohCase?.deactivatedMedicalTypes ?? [];
    const deactivatedMedicalTypes: { id: string; name: string}[] = mergedMedicals.filter(mt => deactivatedMedicalTypeIds?.find(dmtid => dmtid === mt.id)) ?? [];

    const ppqOutcome = getPpqOutcome(props.ohCase?.ppqOutcome?.id);

    const sortedDeactivatedMedicalTypes = sortBy(deactivatedMedicalTypes, [mt => mt.name.toLowerCase()], "name").map(mt => mt.name).join(", ");

    const getOhCaseMedicalsDescription = () => {
        switch (props.ohCase?.isQuestionnaireOnly) {
            case true:
                return "Questionnaire Only";
            case false:
                return "Face to Face Medical Required";
            default:
                return "";
        }
    };

    if (!isLoaded)
    {
        return <Loader active />;
    }

    if (props.ohCase.caseType === CaseType.HEALTH_SURVEILLANCE) {
        return (<>
            {workGroups.length > 0 &&
                <div>
                    <strong>Work Groups:</strong> {sortBy(workGroups, [mt => mt.name.toLowerCase()], "name").map(mt => mt.name).join(", ")}
                    <Divider hidden />
                </div>
            }
            {<div>
                <strong>{getOhCaseMedicalsDescription()}</strong>
                <Divider hidden />
            </div>}
            {ohCaseMedicalTypes &&
                <div>
                    <strong>Medicals:</strong> {sortBy(ohCaseMedicalTypes, [mt => mt.name.toLowerCase()], "name").map(mt => mt.name).join(", ")}
                    <Divider hidden />
                </div>
            }
            {deactivatedMedicalTypes?.length > 0 &&
                <div>
                    <strong>Deactivated medicals:</strong> {sortedDeactivatedMedicalTypes}
                    <Divider hidden />
                </div>
            }
            {ppqOutcome && <div><strong>PPQ Outcome:</strong> {ppqOutcome?.text}</div>}
        </>);
    }

    return null;
};
